import { render, staticRenderFns } from "./MulAcctReceipt.vue?vue&type=template&id=155b619f&"
import script from "./MulAcctReceipt.vue?vue&type=script&lang=js&"
export * from "./MulAcctReceipt.vue?vue&type=script&lang=js&"
import style0 from "./MulAcctReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports